import { Directive } from '@angular/core';
export class BoxInfoContentDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-info-content'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxInfoContentDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxInfoContentDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxInfoContentDirective.ctorParameters;
}

export class BoxInfoFooterDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-info-footer'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxInfoFooterDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxInfoFooterDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxInfoFooterDirective.ctorParameters;
}

export class BoxInfoHeaderDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mk-box-info-header'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoxInfoHeaderDirective_tsickle_Closure_declarations() {
/** @type {?} */
BoxInfoHeaderDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxInfoHeaderDirective.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
